// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1-OPY","content":"styles_content__18Yj-","intro":"styles_intro__1cMSW"};